module.exports = __webpack_public_path__ + "img/5-1.66cc894f.svg";